var XPortal = XPortal || {};
XPortal.CustomEvents = (function () {
    const helpers = {
        /* ---- store events  there: --------------------
        
        async YourEventName1(context, action, next, shipToCode) {            
        
		},
		
        async YourEventName2(context, action, next, shipToCode) {            
        
		}
		
		*/
    };

    //register events in repository
    function waitFor(onAction, onFalse) { if (!onAction()) { setTimeout(function () { onFalse(onAction, onFalse); }, 100); } };     
    waitFor(function () { if (XPortal["Events"] && XPortal["Events"]["helpers"]) { for (var i in helpers) XPortal.Events.helpers[i] = helpers[i]; return true; } else return false;}, waitFor);
	//end of registration
    return helpers;
})();
